import router from '@/router';
export default {
  data: function data() {
    return {
      statementOfAccountModal: true,
      pageTimeOut: 3,
      tempTime: null
    };
  },
  methods: {
    // 跳转对账单（已提交）页面
    handlerToStatementOfAccount: function handlerToStatementOfAccount() {
      this.statementOfAccountModal = false;
      clearInterval(this.tempTime);
      router.push({
        name: 'finMatchingBillList',
        query: {
          orderState: '1004'
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.statementOfAccountModal = true;
    this.tempTime = setInterval(function () {
      if (_this.pageTimeOut > 0) {
        _this.pageTimeOut--;
      } else {
        _this.handlerToStatementOfAccount();
      }
    }, 1000);
  }
};